import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Header from "./components/Navbar"; // your navbar
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Nios from "./pages/Bosse";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import WhatsappButton from "./components/WhatsappButton";
import EnquiryButton from "./components/EnquiryButton";

// Import course-specific pages (you’ll create them inside /pages)
import McaCourse from "./pages/courses/McaCourse";
import MbaCourse from "./pages/courses/MbaCourse";
import McomCourse from "./pages/courses/McomCourse";
import MaCourse from "./pages/courses/MaCourse";
import BcomCourse from "./pages/courses/BcomCourse";
import BcaCourse from "./pages/courses/BcaCourse";
import BbaCourse from "./pages/courses/BbaCourse";
import PhdCourse from "./pages/courses/PhdCourse";
import FloatingCallButton from "./components/FloatingCallButton";
import ScrollToTop from "./components/ScrollToTop";
import Topbar from "./components/Topbar";
import Test from "./components/Test";
import Bosse from "./pages/Bosse";
import NotFound from "./pages/NotFound";
import SecondaryProgramme from "./pages/SecondaryProgramme";
import SeniorSecondaryProgramme from "./pages/SeniorSecondaryProgramme";

export default function App() {
  return (
    <>
      <HelmetProvider>
        <Router>
          <ScrollToTop></ScrollToTop>
          {/* <Topbar></Topbar> */}
          <Header />
          <div>
            {/* marginTop prevents content hiding under fixed navbar */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/courses" element={<Courses />} />

              {/* Course-specific routes */}
              <Route path="/courses/mca" element={<McaCourse />} />
              <Route path="/courses/mba" element={<MbaCourse />} />
              <Route path="/courses/mcom" element={<McomCourse />} />
              <Route path="/courses/ma" element={<MaCourse />} />
              <Route path="/courses/bcom" element={<BcomCourse />} />
              <Route path="/courses/bca" element={<BcaCourse />} />
              <Route path="/courses/bba" element={<BbaCourse />} />
              <Route path="/courses/phd" element={<PhdCourse />} />
              <Route
                path="/secondary-programme"
                element={<SecondaryProgramme />}
              />
              <Route
                path="/senior-secondary"
                element={<SeniorSecondaryProgramme />}
              />

              <Route path="/bosse" element={<Bosse />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogDetail />} />

              <Route path="*" element={<NotFound />} />

              <Route path="/contact" element={<Contact />} />
            </Routes>
          </div>

          <WhatsappButton />
          <EnquiryButton />
          <FloatingCallButton></FloatingCallButton>
          <Footer />
        </Router>
      </HelmetProvider>
    </>
  );
}
